async function getStatesOfAdvertisements() {
  const responsePromise = await fetch('/advertisementsPercentagesState.json');
  return await responsePromise.json();
}

export default getStatesOfAdvertisements;
